function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { FIELD_TYPES } from "constants/template-field-type";
import SharedAdvancedFieldsConfig from "segments/desktop/shared-advanced-fields-config";
import FullParagraphAdvancedFieldsConfig from "segments/desktop/core-components/full-paragraph/advanced-fields-config";
import AssetAdvancedConfig from "components/core/asset/advanced-field-config";
import SideBySideTextAndAssetAdvancedFieldsConfig from "segments/desktop/core-components/side-by-side-text-and-asset/advanced-field-config";
import AssetFieldsConfig from "components/core/asset/fields-config";
export default {
    type: FIELD_TYPES.NESTED,
    label: "",
    fields: _object_spread_props(_object_spread({}, SharedAdvancedFieldsConfig, FullParagraphAdvancedFieldsConfig, AssetAdvancedConfig, SideBySideTextAndAssetAdvancedFieldsConfig), {
        nestedBoardItems: {
            type: FIELD_TYPES.NESTED,
            label: "Embedded Board",
            fields: {
                addLiveBoardTextAndAsset: {
                    type: FIELD_TYPES.BOOLEAN,
                    label: "Add Live Board Experience"
                },
                boardBannerText: {
                    type: FIELD_TYPES.TEXT,
                    label: "Board Banner Text",
                    translatable: true
                },
                embeddedBoardTitle: {
                    type: FIELD_TYPES.TEXT,
                    label: "Embedded Board Title",
                    translatable: true
                },
                addSecondLiveBoardSignUpButton: {
                    type: FIELD_TYPES.BOOLEAN,
                    label: "Add Second Sign Up Button In The Live Board"
                },
                liveBoardToolTipText: {
                    type: FIELD_TYPES.TEXT,
                    label: "Live Board Tooltip Text"
                },
                parallaxAsset: {
                    type: FIELD_TYPES.NESTED,
                    label: "Parallax Asset- IN TEST - DON'T USE",
                    fields: _object_spread({
                        position: {
                            type: FIELD_TYPES.COMBO,
                            label: "Position",
                            options: [
                                "top",
                                "center",
                                "bottom"
                            ]
                        },
                        fitToContainer: {
                            type: FIELD_TYPES.BOOLEAN,
                            label: "Fit to container"
                        }
                    }, AssetFieldsConfig)
                },
                gapBetweenAssets: {
                    type: FIELD_TYPES.TEXT,
                    label: "Gap Between Assets(px)"
                },
                fullParagraphMarginTop: {
                    type: FIELD_TYPES.TEXT,
                    label: "Full Paragraph Margin Top"
                },
                fullParagraphMarginBottom: {
                    type: FIELD_TYPES.TEXT,
                    label: "Full Paragraph Margin Bottom"
                },
                fullParagraphDistanceFromTop: {
                    type: FIELD_TYPES.TEXT,
                    label: "Full Paragraph Distance From Top When Parallax"
                }
            }
        }
    })
};
